import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { BrandMark } from '../components/BrandMark';
import { discountCodes, discountedPrice, formatPrice, pricingPlans } from '../data/pricingPlans';
const foreDiscount = discountCodes[0];
const advanced = pricingPlans.find(plan => plan.id === foreDiscount.planId) || pricingPlans[0];
export function ForeBusinessPage() {
  const standardPrice = advanced.monthlyPrice ?? 0;
  const price = discountedPrice(standardPrice, foreDiscount.percentOff);
  const annualSaving = (standardPrice - price) * 12;
  return <div className="min-h-screen w-full bg-white text-[#041F60]" data-id="element-645" data-mp="209doywjlzs1a">
      <header className="navy-texture border-b border-[#031849]" data-id="element-646" data-mp="2082j8r6lsa7j">
        <div className="mx-auto flex h-16 max-w-5xl items-center justify-between px-5 sm:px-8" data-id="element-647" data-mp="259i2qet4u8nt">
          <a href="/" aria-label="Credit Manager home" className="rounded-lg outline-none focus:ring-2 focus:ring-[#4BE4FF] focus:ring-offset-4 focus:ring-offset-[#041F60]" data-id="element-648" data-mp="3bnhf1rn2sw12">
            <BrandMark inverse data-id="element-649" data-mp="2hdoegg9bremk" />
          </a>
          <span className="rounded-full bg-[#4BE4FF] px-3 py-1 text-xs font-bold text-[#041F60]" data-id="element-650" data-mp="2dcw41jopv3op">
            FORE Business members
          </span>
        </div>
      </header>

      <main className="mx-auto max-w-5xl px-5 py-14 sm:px-8 sm:py-20" data-id="element-651" data-mp="28fcq6kvxksxa">
        <div className="max-w-2xl" data-id="element-652" data-mp="23dx3ypi0ogdb">
          <p className="text-xs font-bold uppercase tracking-[0.16em] text-[#5B5299]" data-id="element-653" data-mp="1yfc2kmr13qna">
            Your member offer
          </p>
          <h1 className="mt-3 text-4xl font-bold tracking-[-0.04em] sm:text-5xl sm:leading-[1.05]" data-id="element-654" data-mp="1todjjfenoegc">
            FORE Business members get{' '}
            <span className="text-[#5B5299] underline decoration-[#4BE4FF] decoration-[0.16em] underline-offset-[0.12em]" data-id="element-655" data-mp="1pna8d67jz6lg">
              {foreDiscount.percentOff}% off
            </span>{' '}
            the ADVANCED plan.
          </h1>
          <p className="mt-5 text-base leading-7 text-[#3A3A3A] sm:text-lg" data-id="element-656" data-mp="1aq1cq0b7vgnx">
            Your discount is already applied — there is no code to enter. Start
            your free trial from day one and the member price holds for the full
            12-month contract period.
          </p>
        </div>

        <section aria-labelledby="offer-title" className="mt-10 grid gap-8 rounded-2xl border border-[#A6B6F8]/60 bg-[#A6B6F8]/15 p-6 sm:p-9 lg:grid-cols-[1.05fr_0.95fr] lg:items-start lg:gap-12" data-id="element-657" data-mp="s1z67l24yu91">
          <div data-id="element-658" data-mp="1jtokr88asy7l">
            <h2 id="offer-title" className="text-sm font-bold uppercase tracking-[0.14em] text-[#5B5299]" data-id="element-659" data-mp="1jt6o4ahq4hz5">
              {advanced.name} plan
            </h2>
            <div className="mt-4 flex flex-wrap items-end gap-x-4 gap-y-2" data-id="element-660" data-mp="1aztkadi4fvya">
              <p className="flex items-baseline gap-2" data-id="element-661" data-mp="1f0veuh13fjtx">
                <span className="text-5xl font-bold tracking-[-0.04em] text-[#041F60]" data-id="element-662" data-mp="22rj0e53xm7yy">
                  {formatPrice(price)}
                </span>
                <span className="text-sm font-semibold text-stone-500" data-id="element-663" data-mp="27j0z0mihfwgr">
                  / month
                </span>
              </p>
              <p className="pb-1.5 text-sm font-semibold text-stone-500" data-id="element-664" data-mp="3s6a64ngza4bm">
                <span className="line-through" data-id="element-665" data-mp="3n99y470kirhv">
                  {formatPrice(advanced.monthlyPrice)}
                </span>{' '}
                standard price
              </p>
            </div>
            <p className="mt-4 text-sm leading-6 text-[#3A3A3A]" data-id="element-666" data-mp="uh4nhs36pkh">
              That is {formatPrice(annualSaving)} saved across your first year,
              compared with the standard {advanced.name} price.
            </p>

            <a href="/signup?plan=advanced&code=FORE" className="mt-7 inline-flex items-center gap-2 rounded-lg bg-[#041F60] px-5 py-3.5 text-sm font-bold text-white transition hover:bg-[#031849] focus:outline-none focus:ring-2 focus:ring-[#041F60] focus:ring-offset-2 focus:ring-offset-[#A6B6F8]/15" data-id="element-667" data-mp="34d22zw19rx0a">
              Start your free trial{' '}
              <ArrowRightIcon size={17} aria-hidden="true" data-id="element-668" data-mp="tkqsik97t9jj" />
            </a>
            <p className="mt-3 text-xs text-stone-500" data-id="element-669" data-mp="2z886x2uu8akl">
              No payment details needed to start your trial.
            </p>
          </div>

          <div className="rounded-xl border border-[#A6B6F8]/60 bg-white p-5 sm:p-6" data-id="element-670" data-mp="387lc3jbxiczi">
            <p className="text-sm font-bold text-[#041F60]" data-id="element-671" data-mp="389xzwd4dbhkh">
              What is included in {advanced.name}
            </p>
            <ul className="mt-4 space-y-3" data-id="element-672" data-mp="3i6audd7qlzga">
              {advanced.features.map(feature => <li key={feature} className="flex gap-3 text-sm leading-6 text-[#3A3A3A]" data-id="element-673" data-mp="3n4c9jn21lemh">
                  <CheckIcon size={16} className="mt-1 shrink-0 text-[#5B5299]" aria-hidden="true" data-id="element-674" data-mp="3rwdvk0p0ijpp" />
                  {feature}
                </li>)}
            </ul>
            <p className="mt-5 border-t border-[#A6B6F8]/50 pt-4 text-xs leading-5 text-stone-500" data-id="element-675" data-mp="9p68iu4bb860">
              {foreDiscount.note}
            </p>
          </div>
        </section>
      </main>

      <footer className="border-t border-[#A6B6F8]/50 bg-white" data-id="element-676" data-mp="eua0r0j3je66">
        <div className="mx-auto flex max-w-5xl flex-col gap-3 px-5 py-8 sm:flex-row sm:items-center sm:justify-between sm:px-8" data-id="element-677" data-mp="ex608taleawq">
          <p className="text-sm font-semibold text-[#041F60]" data-id="element-678" data-mp="5umx082w9w9y">Credit Manager</p>
          <a href="mailto:support@creditmanager.co.uk" className="text-sm font-semibold text-[#5B5299] underline decoration-[#A6B6F8] underline-offset-4 transition hover:text-[#041F60] focus:text-[#041F60] focus:outline-none" data-id="element-679" data-mp="12ke2t3gmz5v2">
            Questions about your member offer? Contact support
          </a>
        </div>
      </footer>
    </div>;
}